import React from "react"
import { useBoundValue } from "lib/@components/binding/use-bound-value"

export const SwitchContext = React.createContext()

export function Switch({ value, field, children, defaultValue }) {
    const [boundValue] = useBoundValue(field, defaultValue)
    return <SwitchContext.Provider value={{ value: value ?? boundValue, cases: {} }}>{children}</SwitchContext.Provider>
}

// Backward-compatible re-exports so existing imports from "lib/@components/switch" keep working
export { If } from "lib/@components/if"
export { Case, CaseElse } from "lib/@components/case"
export { Else } from "lib/@components/else"
